import { render, staticRenderFns } from "./MainAdmin.vue?vue&type=template&id=d7d1bc90&scoped=true"
import script from "./MainAdmin.vue?vue&type=script&lang=js"
export * from "./MainAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d1bc90",
  null
  
)

export default component.exports